import React from 'react';
import {
    TextInput,
    DateInput,
    SimpleForm,
    Edit,
    SelectInput,
    ArrayInput,
    SimpleFormIterator,
    CardActions,
    ListButton, 
    Toolbar, 
    ShowButton,
    SaveButton, 
    BooleanInput,
    FormDataConsumer ,
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import Months from '../../controls/Months'
import Years from '../../controls/Years';
import ErrorBoundary from '../../ErrorBoundary';

var role = (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).role : ''): '';
var level =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).level : ''): '';
var loc= (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).location : ''): '';
var ins_id= null;


export const styles = {

     inlineBlock: {
         display: 'inline-flex', 
         marginRight: '1rem' 
     },
     inlineBlockLeft: {
         display: 'inline-flex',
         float:    'left', 
         marginRight: '1rem' 
     },
     hidden : {
         display: 'none' 
     },
     inputStyle : {
         width :'20px',
     },
     controlInputStyle : {
        width :'70px',
        fontSize: '8'
    },
     labelStyle : {
        width :'40px',
        backgroundColor: 'silver'
    },
    iniLabelStyle : {
        width :'20px',
        backgroundColor: 'silver'
    },
    dateStyle : {
        width: '120px',
        
    },
    tableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'1px solid  black', 
        width: "100%"
    },
    h3: {
        textAlign: 'center',
        width: '100%'
    },
    clearTableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'0px solid  black', 
        width: "100%"
    },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },

 };
 
 const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
const UserEditActions = ({ basePath}) => (
    <CardActions style={cardActionStyle}>
    <ListButton basePath={'/main_AURORA_m?filter=%7B"ins_id"%3A"' + ins_id +'"%7D&order=DESC&page=1&perPage=25&sort=id'} />
</CardActions>
);

const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect={'/main_AURORA_m?filter=%7B"ins_id"%3A"' + ins_id +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const IsPass = [
    {
        id: 'P',
        name: 'Pass'
    },
    {
        id: 'F',
        name: 'Fail'
    }
]

const GetInsID = ({record})=> (
    ins_id  = (record && record.ins_id)? record.ins_id:ins_id
)

const InstEdit = ({classes, ...props }) => (
<ErrorBoundary>      
    <Edit actions={<UserEditActions />}   {...props}  title="Edit">
        <SimpleForm toolbar={<UserCreateToolbar />} >
        <GetInsID props ={props} />
        <table className={classes.clearTableStyle}>
                <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>AURORA</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextInput source='center'  label='' defaultValue={loc} /></td>
                        <td>Aurora ID#:</td><td><TextInput source='eq_id' label=''/></td>
                    </tr>
                    <tr>
                        <td>Month:</td><td><SelectInput source='month' label='' choices={Months} /></td>
                        <td>Year:</td><td><SelectInput source='year' label='' choices={Years} />
                            <TextInput className={classes.hidden} source='ins_id' label='' />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Monthly Maintenance</th>
                                        <th>Tech Initial</th>
                                        <th>Date</th>
                                        <th>QA Initial</th>
                                        <th>Date</th>
                                    </tr>
                                    <tr>
                                        <td>Cleaning of Reservoir channel, Hb detector guide, air detector channel </td>
                                        <td><TextInput source='cr_tech_init' label=''/></td>
                                        <td><DateInput source='cr_tech_dt' label='' /></td>
                                        <td><TextInput source='cr_qa_init' label='' /></td>
                                        <td><DateInput source='cr_qa_dt' label='' /></td>
                                    </tr> 
                                    <tr>
                                        <td>Cleaning of  Pump roller and verification of free turning of pump rollers and replacements of worn 
                                            or loose components if necessary</td>
                                        <td><TextInput source='cp_tech_init' label=''/></td>
                                        <td><DateInput source='cp_tech_dt' label='' /></td>
                                        <td><TextInput source='cp_qa_init' label='' /></td>
                                        <td><DateInput source='cp_qa_dt' label='' /></td>
                                    </tr> 
                                    <tr>
                                        <td>Inspection of transducer Luers for blockage or damage to the outside surface</td>
                                        <td><TextInput source='it_tech_init' label=''/></td>
                                        <td><DateInput source='it_tech_dt' label='' /></td>
                                        <td><TextInput source='it_qa_init' label='' /></td>
                                        <td><DateInput source='it_qa_dt' label='' /></td>
                                    </tr> 
                                    <tr>
                                        <td>Removal and cleaning of lower air filter </td>
                                        <td><TextInput source='rm_tech_init' label=''/></td>
                                        <td><DateInput source='rm_tech_dt' label='' /></td>
                                        <td><TextInput source='rm_qa_init' label='' /></td>
                                        <td><DateInput source='rm_qa_dt' label='' /></td>
                                    </tr> 
                                    <tr>
                                        <td colSpan={5}><TextInput source='comments' label='Comments' fullWidth minRows={4} /></td>
                                    </tr>
                                    <FormDataConsumer>
                                    {({
                                        formData, // The whole form data
                                        scopedFormData, // The data for this item of the ArrayInput
                                        getSource, // A function to get the valid source inside an ArrayInput
                                        ...rest
                                    }) =>
                                        ( role==='QA' || role==='Admin' || level > 6 )? (
                                        <>
                                        <tr>
                                            <td><BooleanInput source='is_qa' label='Is Monthly QA Approved?' /></td>
                                            <td>QA Initial:</td><td><TextInput source='m_qa_init' label='' /></td>
                                            <td>QA Date:</td><td><DateInput source='m_qa_dt' label='' locales='en-us' /></td>
                                        </tr>
                                        
                                        </>
                                    ):''
                                        }
                                    </FormDataConsumer>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </SimpleForm>        
    </Edit>
    </ErrorBoundary>  
);

export default withStyles(styles) (InstEdit);
